// @ts-nocheck
import { Helmet } from 'react-helmet-async';
import VuiBreadcrumb from '../../../../../vodea/@vodea-ui/components/VuiBreadcrumb';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useIsMounted from '../../../../../vodea/utilities/hooks/useIsMounted';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { InformationInputs, informationSchema, ItemInputs, itemSchema } from './validation';
import { yupResolver } from '@hookform/resolvers/yup';
import VuiActionForm from '../../../../../vodea/@vodea-ui/components/Forms/VuiActionForm';
import { useState } from '@hookstate/core/dist';
import clsx from 'clsx';
import VuiSelect from '../../../../../vodea/@vodea-ui/components/Forms/VuiSelect';
import _ from 'lodash';
import VuiDateRangePicker from '../../../../../vodea/@vodea-ui/components/Forms/VuiDateRangePicker';
import moment from 'moment';
import BootstrapTable from 'react-bootstrap-table-next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal } from 'react-bootstrap';
import { VuiButton } from '../../../../../vodea/@vodea-ui/components/VuiButton';
import NumberFormat from 'react-number-format';
import { $clone } from '../../../../../vodea/utilities';
import VuiActionModal from '../../../../../vodea/@vodea-ui/components/Modal/VuiActionModal';
import { formatFormData } from '../../../../../vodea/utilities/helpers/form';
import { AxiosError, AxiosResponse } from 'axios';
import { mapHookErrors, showToast } from '../../../../../vodea/utilities/helpers/global';
import VuiNumberFormat from '../../../../../vodea/@vodea-ui/components/VuiNumberFormat';
import StockOpnameRepository from '../../../../../repositories/StockOpnameRepository';
import ProductRepository from '../../../../../repositories/ProductRepository';
import StorageRepository from '../../../../../repositories/StorageRepository';

const StockOpnameAddPage: React.FC<any> = () => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const title = t('Create Stock Opname');

  const productLoading = useState(false);
  const informationLoading = useState(false);
  const {
    handleSubmit: informationHandleSubmit,
    errors: informationErrors,
    control: informationControl,
    setValue: informationSetValue,
    setError: informationSetError,
    watch: informationWatch
  } = useForm<InformationInputs>({
    defaultValues: {
      date: moment().format('YYYY-MM-DD'),
      stock_opname_products: []
    }
  });

  const onInformationSubmit = informationHandleSubmit(data => {
    informationLoading.set(true);

    const formData = formatFormData(data);

    if (moment.isMoment(data['date'])) {
      formData['date'] = data['date'].format('YYYY-MM-DD');
    }

    Object.assign(formData, {
      stock_opname_products: []
    });

    if (itemFields.length !== 0) {
      itemFields.forEach((item: any, key: number) => {
        formData.stock_opname_products[key] = formatFormData(item);
      });
    }

    StockOpnameRepository.form(formData)
      .then((response: AxiosResponse) => {
        showToast(response.data.message, response.data.success ? 'success' : 'error');
        navigate('/inventory/stock-opname');
      })
      .catch((e: AxiosError) => {
        if (isMounted.current && e?.response?.data?.errors) {
          const errors = mapHookErrors(e.response.data.errors);
          Object.keys(errors).forEach((key: any) => {
            informationSetError(key, errors[key]);
          });

          showToast(e.response.data.message, 'error');
        }

        informationLoading.set(false);
      });
  });

  const {
    fields: itemFields,
    append: itemAppend,
    remove: itemRemove,
    insert: itemInsert
  } = useFieldArray({
    keyName: 'key',
    name: 'stock_opname_products',
    control: informationControl
  });

  const selectedItemIndex = useState(-1);
  const showItemModal = useState(false);

  const itemLoading = useState(false);
  const {
    handleSubmit: itemHandleSubmit,
    register: itemRegister,
    control: itemControl,
    errors: itemErrors,
    reset: itemReset,
    setError: itemSetError,
    setValue: itemSetValue,
    watch: itemWatch
  } = useForm<ItemInputs>({
    resolver: yupResolver(itemSchema),
    defaultValues: {
      storage_id: null,
      product_id: null,
      quantity: 0,
      price: 0
    }
  });

  const watchProductId = itemWatch('product_id');
  const watchStorageId = itemWatch('storage_id');
  const onItemSubmit = itemHandleSubmit(data => {
    const tempData = {
      ...data
    };

    if (selectedItemIndex.get() === -1) {
      itemAppend(tempData);
    } else {
      itemInsert(selectedItemIndex.get() + 1, tempData);
      itemRemove(selectedItemIndex.get());
    }

    showItemModal.set(false);
  });

  const itemDeleteIndex = useState(0);
  const showItemDeleteModal = useState(false);

  const handleItemClickDelete = (index: number) => {
    itemDeleteIndex.set(index);
    showItemDeleteModal.set(true);
  };

  const handleItemDelete = () => {
    itemRemove(itemDeleteIndex.get());
    showItemDeleteModal.set(false);
    itemDeleteIndex.set(0);
  };

  const handleShowItemProduct = async (show: boolean, index: number = -1) => {
    itemReset();
    selectedItemIndex.set(index);

    if (index != -1) {
      const selectedData = $clone(itemFields[index]);

      setTimeout(() => {
        itemSetValue('id', _.get(selectedData, 'id'));
        itemSetValue('product_id', _.get(selectedData, 'product_id'));
        itemSetValue('storage_id', _.get(selectedData, 'storage_id'));
        itemSetValue('quantity', _.get(selectedData, 'quantity'));
        itemSetValue('price', _.get(selectedData, 'price'));
      }, 200);
    }

    showItemModal.set(show);
  };

  const itemColumns = [
    {
      dataField: 'product_id.name',
      text: 'Product'
    },
    {
      dataField: 'storage_id.name',
      text: 'Storage'
    },
    {
      dataField: 'quantity',
      text: 'Quantity',
      formatter: (cell: any, row: any) => {
        return <VuiNumberFormat data={cell} prefix={'IDR '} />;
      }
    },
    {
      dataField: 'price',
      text: 'Price',
      formatter: (cell: any, row: any) => {
        return <VuiNumberFormat data={cell} prefix={'IDR '} />;
      }
    },
    {
      dataField: 'action',
      text: 'Action',
      headerAlign: 'center',
      isDummyField: true,
      align: 'center',
      formatter: (cell: any, row: any, rowIndex: number) => {
        return (
          <div className={'table-btn-wrapper'}>
            <button type={'button'} className={'btn btn-primary btn-small'} onClick={() => handleShowItemProduct(true, rowIndex)}>
              <FontAwesomeIcon icon={faPencilAlt} />
            </button>
            <button type={'button'} className={'btn btn-danger btn-small'} onClick={() => handleItemClickDelete(rowIndex)}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </div>
        );
      }
    }
  ];

  const breadcrumbList = [
    {
      label: t('Inventory'),
      link: '/inventory'
    },
    {
      label: t('Stock Opname'),
      link: '/inventory/stock-opname'
    },
    {
      label: t('Create'),
      link: '/inventory/stock-opname/add'
    }
  ];

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <div className={'page-header-component'}>
        <h3 className={'title'}>{title}</h3>
      </div>

      <form className={'form-wrapper'} onSubmit={onInformationSubmit}>
        <div className='default-page-layout layout-reverse'>
          <div className='information-section'>
            <div className={'card-paper'}>
              <div className={'card-header'}>
                <h6 className={'card-header-title'}>{t('Information')}</h6>
              </div>
              <div className={'card-content'}>
                <div
                  className={clsx({
                    'form-group': true
                  })}
                >
                  <label className={'form-label'}>Number</label>
                  <input type='text' className='form-control' disabled />
                </div>

                <div
                  className={clsx({
                    'form-group': true
                  })}
                >
                  <label className={'form-label'}>Date</label>
                  <input type='text' className='form-control' disabled />
                </div>
              </div>
            </div>
          </div>

          <div className='multiple-paper-section'>
            <div className='card-paper'>
              <div className={'card-header'}>
                <h6 className={'card-header-title'}>Product List</h6>
              </div>
              <div className='card-content'>
                <BootstrapTable keyField='key' data={$clone(itemFields)} columns={itemColumns} />

                <button type={'button'} className={'btn btn-primary btn-small'} onClick={() => handleShowItemProduct(true)}>
                  <FontAwesomeIcon className={'icon icon-prefix'} icon={faPlus} />
                  {t('Add Product')}
                </button>
              </div>
            </div>
          </div>
        </div>

        <VuiActionForm loading={informationLoading.get()} cancelLink={'/inventory/stock-opname'} />
      </form>

      <Modal show={showItemModal.get()} onHide={() => showItemModal.set(false)} backdrop={'static'} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedItemIndex.get() === -1 ? t('Add Product') : t('Edit Product')}</Modal.Title>
        </Modal.Header>
        <form className={'form-wrapper'} onSubmit={onItemSubmit}>
          <Modal.Body>
            <Controller
              name={'id'}
              control={itemControl}
              defaultValue={0}
              render={props => <input type={'hidden'} defaultValue={props.value} />}
            />

            <div
              className={clsx({
                'form-group': true,
                error: itemErrors.storage_id
              })}
            >
              <label className={'form-label'}>Storage</label>
              <Controller
                name={'storage_id'}
                control={itemControl}
                defaultValue={null}
                render={props => (
                  <VuiSelect
                    selectParams={{
                      for: 'sales-order'
                    }}
                    selectRepository={StorageRepository}
                    defaultValue={props.value}
                    onChange={val => {
                      props.onChange(val);
                    }}
                    isMulti={false}
                  />
                )}
              />
              <label className={'label-help'}>{_.get(itemErrors.storage_id, 'message')}</label>
            </div>

            <div
              className={clsx({
                'form-group': true,
                error: itemErrors.product_id
              })}
            >
              <label className={'form-label'}>Product</label>
              <Controller
                name={'product_id'}
                control={itemControl}
                render={props => (
                  <VuiSelect
                    propKey={_.get(watchStorageId, 'id')}
                    selectParams={{
                      // for: 'sales-order',
                      with: ['productConversions'],
                      storage: _.get(watchStorageId, 'id')
                    }}
                    selectRepository={ProductRepository}
                    defaultValue={props.value}
                    onChange={val => {
                      props.onChange(val);
                      itemSetValue('quantity', Number(val?.current_stock ?? 0));
                      itemSetValue('price', Number(val?.average_price ?? 0));
                    }}
                    isDisabled={watchStorageId === null}
                  />
                )}
              />
              <label className={'label-help'}>{_.get(itemErrors.product_id, 'message')}</label>
            </div>

            <div
              className={clsx({
                'form-group': true,
                error: itemErrors.quantity
              })}
            >
              <label className={'form-label'}>Quantity</label>
              <Controller
                name={'quantity'}
                control={itemControl}
                defaultValue={null}
                render={props => (
                  <NumberFormat
                    className='form-control'
                    value={props.value}
                    allowNegative={false}
                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    decimalScale={0}
                    placeholder={'0'}
                    onValueChange={({ value }) => {
                      props.onChange(value);
                    }}
                  />
                )}
              />
              <label className={'label-help'}>{itemErrors.quantity?.message}</label>
            </div>

            <div
              className={clsx({
                'form-group': true,
                error: itemErrors.price
              })}
            >
              <label className={'form-label'}>Price</label>
              <Controller
                name={'price'}
                control={itemControl}
                defaultValue={null}
                render={props => (
                  <NumberFormat
                    className='form-control'
                    value={props.value}
                    allowNegative={false}
                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    decimalScale={0}
                    placeholder={'IDR 0'}
                    prefix={'IDR '}
                    onValueChange={({ value }) => {
                      props.onChange(value);
                    }}
                  />
                )}
              />
              <label className={'label-help'}>{itemErrors.price?.message}</label>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant={'light'} onClick={() => showItemModal.set(false)}>
              {t('Cancel')}
            </Button>
            <VuiButton forSubmit={true} label={'Save'} loading={productLoading.get()} />
          </Modal.Footer>
        </form>
      </Modal>

      <VuiActionModal show={showItemDeleteModal.get()} onHide={() => showItemDeleteModal.set(false)} onContinue={handleItemDelete} />
    </>
  );
};

export default StockOpnameAddPage;
